import React, { useEffect } from "react";
import styles from "./Styles.module.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateEndTime } from "../DAL/dal";

const Finish = ({ sessionId, devMode }) => {
  const { isCurrentStage } = useSelector(
    (state) => state.currentCase.futureTreatment
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (!devMode)
      updateEndTime(sessionId)
        .then((r) => r)
        .catch((e) => console.log(e));
    if (!isCurrentStage) navigate("/");
  }, []);

  return (
    <section
      style={{ justifyContent: "center" }}
      className={styles.containerHeadInf}
    >
      <div style={{ fontSize: "28px", textAlign: "center" }}>
        Спасибо за Ваше участие!
      </div>
      <button className="buttonNext" onClick={() => window.location.reload()}>
        Пройти заново
      </button>
    </section>
  );
};

export default Finish;
